__turbopack_context__.v({
  "container": "advanced-search-module-scss-module__X9oIVa__container",
  "pending": "advanced-search-module-scss-module__X9oIVa__pending",
  "searchQuery": "advanced-search-module-scss-module__X9oIVa__searchQuery",
  "searchQueryExplanation": "advanced-search-module-scss-module__X9oIVa__searchQueryExplanation",
  "submitButton": "advanced-search-module-scss-module__X9oIVa__submitButton",
  "subtitle": "advanced-search-module-scss-module__X9oIVa__subtitle",
  "suggestion": "advanced-search-module-scss-module__X9oIVa__suggestion",
});
